import { API } from '../api'
import { Unit, UnitsResponse } from './interface'

export const fetchAll = async (
  filtros: Record<string, any>
): Promise<{
  items: Unit[]
  total: number
}> => {
  try {
    const response = await API.get<UnitsResponse>(
      '/logistica/item/buscar-por-operadora',
      filtros
    )
    const results: Unit[] = response.content.itens ?? []

    const total = response.content.total ?? 0

    return { items: results, total }
  } catch (error) {
    console.error('Erro ao buscar unidades:', error)
    return { items: [], total: 0 }
  }
}
